import "./index.css"

export const ECDiagrams = () => {
    return ( <div className="ec-diagrams-container">
    <div className="block-label-containers">
      <div className="block-label-container">
        <div className="block-thumbnail s-block">s</div>
        <label className="block-label">block</label>
      </div>

      <div className="block-label-container">
        <div className="block-thumbnail p-block">p</div>
        <label className="block-label">block</label>
      </div>

      <div className="block-label-container">
        <div className="block-thumbnail d-block">d</div>
        <label className="block-label">block</label>
      </div>

      <div className="block-label-container">
        <div className="block-thumbnail f-block">f</div>
        <label className="block-label">block</label>
      </div>
    </div>

    <div className="s-block-config-container">
        <div className="s-block-item s-block-item-label">7s</div>
        <div className="s-block-item s-block-item-electrons"></div>

        <div className="s-block-item s-block-item-label">6s</div>
        <div className="s-block-item s-block-item-electrons"></div>

        <div className="s-block-item s-block-item-label">5s</div>
        <div className="s-block-item s-block-item-electrons"></div>

        <div className="s-block-item s-block-item-label">4s</div>
        <div className="s-block-item s-block-item-electrons"></div>

        <div className="s-block-item s-block-item-label">3s</div>
        <div className="s-block-item s-block-item-electrons"></div>

        <div className="s-block-item s-block-item-label">2s</div>
        <div className="s-block-item s-block-item-electrons"></div>

        <div className="s-block-item s-block-item-label">1s</div>
        <div className="s-block-item s-block-item-electrons"></div>

    </div>

    <div className="p-block-config-container">
        <div className="p-block-item p-block-item-label">7p</div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>

        <div className="p-block-item p-block-item-label">6p</div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>

        <div className="p-block-item p-block-item-label">5p</div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>

        <div className="p-block-item p-block-item-label">4p</div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>

        <div className="p-block-item p-block-item-label">3p</div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>

        <div className="p-block-item p-block-item-label">2p</div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>
        <div className="p-block-item p-block-item-electrons"></div>

       
    </div>

    <div className="d-block-config-container">
        <div className="d-block-item d-block-item-label">6d</div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>

        <div className="d-block-item d-block-item-label">5d</div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>

        <div className="d-block-item d-block-item-label">4d</div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>

        <div className="d-block-item d-block-item-label">3d</div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>
        <div className="d-block-item d-block-item-electrons"></div>

    </div>

    <div className="f-block-config-container">
        <div className="f-block-item f-block-item-label">5f</div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>

        <div className="f-block-item f-block-item-label">4f</div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>
        <div className="f-block-item f-block-item-electrons"></div>

    </div>



  </div>);
}